import styled from 'styled-components';
import { pxToRem, Card, Link } from 'src/viewLayer/components/DesignSystem';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import type { BabbelTheme } from '@lessonnine/design-tokens.lib/dist/json/theme';

import devices from 'src/viewLayer/styling/mixins/mediaQueries';

export const InformationBoxContainer = styled(Card)`
  background-color: ${({ theme }: { theme: BabbelTheme }): string => theme.color.surface.layer.background};
  border: 1px solid ${({ theme }: { theme: BabbelTheme }): string => theme.color.surface.layer.border};
  color: ${({ theme }: { theme: BabbelTheme }): string => theme.color.surface.foreground.primary};
  padding: ${tokens.size.space.medium};
  width: 100%;

  @media ${devices.fromxxsmall} {
    max-width: 390px;
  }

  @media ${devices.fromsmall} {
    max-width: 518px;
  }
`;

export const InformationBoxLink = styled(Link)`
  margin-top: ${pxToRem(4)};
  vertical-align: 'text-bottom';
  line-height: 1rem;
`;
